import React, { useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import {
  createStyles,
  makeStyles,
  Theme,
  Tooltip,
  IconButton
} from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { AuthInfoContext } from '../../AuthContextProvider';
import { ROLE } from '../../const/Const';

type TProps = {
  setErrorMessage: any;
  setOpenError: any;
};

export const FactoringAlerts: React.FC<TProps> = (props: TProps) => {
  const { setErrorMessage, setOpenError } = props;
  const classes = useStyles();
  const location = useLocation();

  const [authInfo] = useContext(AuthInfoContext);
  const [openModal, setOpenModal] = useState(false);

  // 経営者権限以外は表示しない or パスが "/dashboard" 以外は表示しない
  if (authInfo?.role !== ROLE.EXECUTIVE || location.pathname !== '/dashboard')
    return null;

  return (
    <div className={classes.alertWapper}>
      <Tooltip
        title={
          <span className={classes.tooltipText}>
            お得な資金繰り改善
            <br />
            サービスのご案内
            <br />
            <br />
            ※（株）ラボル様のページに
            <br />
            遷移いたします
          </span>
        }
        arrow
        classes={{ tooltip: classes.tooltip }}
      >
        <IconButton className={classes.helpIcon} size='small'>
          <HelpOutlineIcon fontSize='small' />
        </IconButton>
      </Tooltip>
      <a
        href='https://labol.co.jp/about-partnership/conoc'
        target='_blank'
        rel='noopener noreferrer'
        className={classes.link}
      >
        <div className={classes.alert}>(!) ファクタリングサービスお知らせ</div>
      </a>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    alertWapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: theme.spacing(1),
      gap: theme.spacing(1)
    },
    link: {
      textDecoration: 'none',
      display: 'flex',
      justifyContent: 'center'
    },
    alert: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#f0fff4',
      color: '#2e7d32',
      height: 'auto',
      border: 'solid 1px #66bb6a',
      borderRadius: '4px',
      padding: '4px 16px',
      fontSize: '0.9rem'
    },
    helpIcon: {
      color: '#ffffff',
      backgroundColor: '#33A1DE',
      borderRadius: '50%',
      padding: 4,
      '&:hover': {
        backgroundColor: '#2890C5'
      }
    },
    tooltip: {
      fontSize: '0.9rem',
      lineHeight: 1.6,
      maxWidth: 280,
      whiteSpace: 'pre-line',
      textAlign: 'center'
    },
    tooltipText: {
      display: 'block'
    }
  })
);
